import React from 'react';

function Download() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />{' '}
    </svg>
  );
  /* eslint-enable */
}

export default Download;



// WEBPACK FOOTER //
// ./src/common/icons/Download.js